/*==========================
 Facebook Module for angularjs
 Author : Aeggli
 2013 / 08 / 15
==========================*/

angular.module('facebook.config', [])
  .factory('fbconfig', ['$window', function($window){

    var fbconfig = new Object();
    if (window.location.toString().toLowerCase().indexOf("localhost") !== -1) {
        fbconfig.appId = '213385405389839';
    } else if (window.location.toString().toLowerCase().indexOf("inifec.taocart.") !== -1) {
        fbconfig.appId = '365422674237634';
    } else if (window.location.toString().toLowerCase().indexOf("inif.com.tw") !== -1) {
        fbconfig.appId = '365422674237634';
    }
    
    return fbconfig;
  }]);

// Facebook SDK
// https://gist.github.com/ruiwen/4722499
angular.module('facebook', [])
    .directive('fb', ['fbconfig','$FB', function(fbconfig,$FB) {
        return {
            restrict: "E",
            replace: true,
            template: "<div id='fb-root'></div>",
            compile: function(tElem, tAttrs) {
                return {
                    post: function(scope, iElem, iAttrs, controller) {
                        var fbAppId = iAttrs.appId || fbconfig.appId || '';

                        var fb_params = {
                            appId: fbAppId,
                            cookie: iAttrs.cookie || true,
                            status: iAttrs.status || true,
                            xfbml: iAttrs.xfbml || true,
                            channelUrl: fbconfig.channelURL || "" ,
                            frictionlessRequests: iAttrs.frictionlessRequests || true,
                            version: 'v14.0'
                            // version: 'v8.0'

                        };

                        // Setup the post-load callback
                        window.fbAsyncInit = function() {
                            $FB._init(fb_params);

                            if('fbInit' in iAttrs) {
                                iAttrs.fbInit();
                            }
                        };

                        (function(d, s, id, fbAppId) {
                            var js, fjs = d.getElementsByTagName(s)[0];
                            if (d.getElementById(id)) return;
                            js = d.createElement(s); js.id = id; js.async = true;
                            if(window.location.protocol == "file:"){
                                js.src = "https://connect.facebook.net/zh_TW/sdk.js";
                            } else {
                                js.src = "//connect.facebook.net/zh_TW/sdk.js";    
                            }
                            
                            fjs.parentNode.insertBefore(js, fjs);
                        }(document, 'script', 'facebook-jssdk', fbAppId));

                        // (function(d, s, id) {
                        //     var js, fjs = d.getElementsByTagName(s)[0];
                        //     if (d.getElementById(id)) return;
                        //     js = d.createElement(s); js.id = id;
                        //     if(window.location.protocol == "file:"){
                        //         js.src = "https://connect.facebook.net/zh_TW/sdk/xfbml.customerchat.js";
                        //     } else {
                        //         js.src = "//connect.facebook.net/zh_TW/sdk/xfbml.customerchat.js";    
                        //     }

                        //     fjs.parentNode.insertBefore(js, fjs);
                        // }(document, 'script', 'facebook-customerchat-jssdk'));

                        // // fb 聊天室
                        // (function(d, s, id) {
                        //     var div, fdiv = d.getElementsByTagName(s)[0];
                        //     if (d.getElementById(id)) return;
                        //     div = d.createElement(s); div.id = id;
                            
                        //     div.setAttribute("class", "fb-customerchat");
                        //     div.setAttribute("attribution", "setup_tool");
                        //     div.setAttribute("page_id", "244585622286624");
                        //     div.setAttribute("theme_color", "#ee7b68");

                        //     fdiv.parentNode.insertBefore(div, fdiv);
                        // }(document, 'div', 'facebook-customerchat'));
                    }
                }
            }
        };
    }])

    .factory('$FB', ['$rootScope', function($rootScope) {


        var fbLoaded = false;

        // Our own customisations
        var _fb =  {
            loaded: fbLoaded,
            isLoaded : function(){
                return this.loaded;
            },
            authenticated : false,
            isAuthenticated : function(){
                return this.authenticated;
            },
            _init: function(params) {

                self = this;

                if(window.FB) {

                    // FIXME: Ugly hack to maintain both window.FB
                    // and our AngularJS-wrapped $FB with our customisations
                    angular.extend(window.FB, this);
                    angular.extend(this, window.FB);

                    // Set the flag
                    this.loaded = true;

                    // Initialise FB SDK
                    window.FB.init(params);

                    window.FB.Event.subscribe('auth.authResponseChange', function(response) {
                        if (response.status === 'connected') {
                          self.authenticated = true;
                        }
                    });


                    if(!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                }
            }
        }

        return _fb;
    }]);

angular.module('facebook.stream', ['facebook'])
    .factory('fbSteamFactory', ['$rootScope', '$FB', function($rootScope) {
        // 檢查權限
        $FB.login(function(resposne){
            debugger
        }, {scope: 'read_stream'});



    }]);
